<modus-wc-utility-panel
  class="agentic-chat-drawer-panel"
  [class.agentic-chat-drawer-panel--collapsed]="!isOpen()"
  customClass="agentic-chat-drawer-panel"
  [expanded]="isOpen()"
  [pushContent]="usePushContent()"
  [targetElement]="pushTarget()"
  [backgroundOverlay]="false"
  aria-label="AI Assistant"
  (panelClosed)="onPanelClosed()"
>
  <div slot="header" class="agentic-chat-panel-header">
    <modus-wc-typography
      hierarchy="h4"
      size="sm"
      weight="semibold"
      label="AI Assistant"
    ></modus-wc-typography>
    <modus-wc-button
      variant="borderless"
      color="tertiary"
      shape="square"
      size="sm"
      buttonAriaLabel="Close AI Assistant"
      [id]="getTestId('Header', 'Button', 'Close')"
      [attr.data-test-field]="getTestId('Header', 'Button', 'Close')"
      (buttonClick)="closePanel()"
    >
      <modus-wc-icon name="close" size="sm" decorative></modus-wc-icon>
    </modus-wc-button>
  </div>
  <div slot="body" class="agentic-chat-drawer-body-slot">
    <iframe
      #chatFrame
      class="agentic-chat-frame"
      [src]="chatUiUrl()"
      title="AI Assistant"
      [id]="getTestId('Iframe', 'ChatUi')"
      [attr.data-test-field]="getTestId('Iframe', 'ChatUi')"
      allow="clipboard-read; clipboard-write"
    ></iframe>
  </div>
</modus-wc-utility-panel>
